import moment from 'moment'
import React from 'react'

import { MasterCampaignPlanCampaignBuilder } from 'api/interfaces/MasterCampaignStub'

import { typeColors } from '../utils'
import CampaignBar from './CampaignBar'

export interface CampaignRowData {
  campaigns: MasterCampaignPlanCampaignBuilder[]
  rowIndex: number
  minDate: moment.Moment
  totalMonthsToShow: number
  ganttChartRef?: React.RefObject<HTMLDivElement>
  hoveredType: string | null
  isClickable: boolean
}

const CampaignRow: React.FC<CampaignRowData> = ({ campaigns, rowIndex, minDate, totalMonthsToShow, ganttChartRef, hoveredType, isClickable }) => {
  return (
    <div
      key={rowIndex}
      style={{
        height: '32px',
        marginBottom: '4px',
        position: 'relative'
      }}>
      {campaigns.map(campaign => (
        <CampaignBar key={campaign.id} campaign={campaign} minDate={minDate} totalMonthsToShow={totalMonthsToShow} ganttChartRef={ganttChartRef} hoveredType={hoveredType} isClickable={isClickable} />
      ))}
    </div>
  )
}

export default CampaignRow
